// React
import React from "react";

import { formatDate } from "../../../../Helpers/formatters";

// Material UI
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

const LatestLeadsBody = ({
  leads,
  getComparator,
  page,
  rowsPerPage,
  stableSort,
  order,
  orderBy,
}) => {
  return (
    <TableBody>
      {stableSort(leads, getComparator(order, orderBy))
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map(({customerId, firstname, lastname, campaignName, emailAddress, ip, visitorHash, leadDate}, index) => {
          return (
            <TableRow key={index}>
              <TableCell className="tableCell" align="center">
                {customerId}
              </TableCell>
              <TableCell className="tableCell" align="center">
                {firstname + " " + lastname}
              </TableCell>
              <TableCell className="tableCell" align="center">
                {campaignName}
              </TableCell>
              <TableCell className="tableCell" align="center">
                {emailAddress}
              </TableCell>
              <TableCell className="tableCell" align="center">
                {ip ? ip : "No IP Present"}
              </TableCell>
              <TableCell className="tableCell" align="center">
                {visitorHash}
              </TableCell>
              <TableCell className="tableCell" align="center">
                {formatDate(leadDate)}
              </TableCell>
            </TableRow>
          );
        })}
    </TableBody>
  );
};

export default LatestLeadsBody;
